<template>
  <div class="col-12">
    <div class=" row text-center m-5">
      <h3 class="ui inverted purple text"><strong> Failed</strong></h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-9">
      <div class="ui violet floating message m-4">
        <div class="header mb-2">
          TN CyberTech Bank
        </div>
        <p>Apologies, unfortunately an error has occurred. Please contact us on 0808 8888 or customerservice@stewardbank.co.zw for assistance.</p>
      </div>
                <button class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>

    </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";

export default {
  name: 'T24Failed',
  data() {
    return {
      customer: {
        mobileNumber: ""
      },
      errors: {},
      operations: 0,
    };
  },
  mounted() {

      const model = localStorage.getItem('model');
      console.log('Retrieved Object Model : ', JSON.parse(model));

  },
  methods: {
    login() {
      this.$router.push("/account-opening/login");
    },
    ...baseMethods,
  }
};
</script>